import { inject, Injectable } from '@angular/core';
import { Router, NavigationEnd, Event } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NavigationInterceptorHelper {
  
  private isRedirectingFromMsal = false;
  /* 
  * Injections
  */
  private router:                                         Router = inject(Router);

  constructor() {

    this.setupInterceptor();
  }

  private setupInterceptor() {

    if (window.location.href.includes('#/#')) {

      this.isRedirectingFromMsal = true;
    }
    
    setTimeout(() => this.cleanupAndNavigate(), 10);
    
    this.router.events.pipe(filter(( event : Event ) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      
      if (event.url === '/' && window.location.hash && window.location.hash !== '#/') {
        
        const targetPath = window.location.hash.substring(1); 
        
        setTimeout(() => this.router.navigateByUrl(targetPath), 50);
      }
    });
  }

  private cleanupAndNavigate() {

    const currentUrl = window.location.href;
    let needsCleanup = false;
    let newUrl = currentUrl;
    let targetPath = '';
    
    if (currentUrl.includes('/#/#')) {
      
      newUrl = currentUrl.replace('/#/#', '/#');
      needsCleanup = true;
      
      const hashPart = newUrl.split('#')[1];
      
      if (hashPart && hashPart !== '/') {
        
        targetPath = hashPart;
      }
    }
    
    if (currentUrl.includes('/index.html#/#')) {
      
      newUrl = currentUrl.replace('/index.html#/#', '/index.html#');
      needsCleanup = true;
      
      const hashPart = newUrl.split('#')[1];
      
      if (hashPart && hashPart !== '/') {
        
        targetPath = hashPart;
      }
    }
    
    if (currentUrl.includes('##')) {
      
      newUrl = currentUrl.replace('##', '#');
      needsCleanup = true;
      
      const hashPart = newUrl.split('#')[1];
      
      if (hashPart && hashPart !== '/') {
        
        targetPath = hashPart;
      }
    }
    
    if (needsCleanup && newUrl !== currentUrl) {
      
      window.history.replaceState(window.history.state, '', newUrl);
    }
    
    if (targetPath && (this.isRedirectingFromMsal || needsCleanup)) {
      
      setTimeout(() => {
        
        this.router.navigateByUrl(targetPath).then(success => {
          
          /* console.log(success) */

          this.isRedirectingFromMsal = false;
       
        }).catch(error => {
          
          console.error('Error en navegación:', error);
        });
      }, 100);
    }
  }
}